import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Typography,
  Box
} from '@mui/material';
import moment from 'moment';
import CloseIcon from '@mui/icons-material/Close';

const ResidentHistoryDialog = ({ open, onClose, historyData, onDuplicateConfirm }) => {
  const hasActiveBooking = historyData.some(history => 
    history.Msg === 'Active' || history.BookStatus === 'Active'
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          margin: 0,
          padding: 0
        }
      }}
    >
      <DialogTitle sx={{ padding: '8px 16px', margin: 0 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Resident History <span style={{ color: 'red' }}>Previous booking history</span>
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="small"
            sx={{ padding: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        {historyData.length > 0 ? (
          <>
            <TableContainer>
              <Table sx={{ borderCollapse: 'collapse' }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: '4px', fontWeight: 'bold', border: '1px solid #ddd' }}>Booking No</TableCell>
                    <TableCell sx={{ padding: '4px', fontWeight: 'bold', border: '1px solid #ddd' }}>Check-In Date</TableCell>
                    <TableCell sx={{ padding: '4px', fontWeight: 'bold', border: '1px solid #ddd' }}>Check-Out Date</TableCell>
                     <TableCell sx={{ padding: '4px', fontWeight: 'bold', border: '1px solid #ddd' }}>Tenure</TableCell>
                    <TableCell sx={{ padding: '4px', fontWeight: 'bold', border: '1px solid #ddd' }}>Status</TableCell>
 
                  </TableRow>
                </TableHead>
                <TableBody>
                  {historyData.map((history, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ padding: '4px', border: '1px solid #ddd' }}>{history.TrjNo || 'N/A'}</TableCell>
                      <TableCell sx={{ padding: '4px', border: '1px solid #ddd' }}>
                        {history.TrjDt ? moment(history.TrjDt).format("DD-MM-YYYY") : 'N/A'}
                      </TableCell>
                      <TableCell sx={{ padding: '4px', border: '1px solid #ddd' }}>
                        {history.ModifiedDate ? moment(history.ModifiedDate).format("DD-MM-YYYY") : 'N/A'}
                      </TableCell>
                        <TableCell sx={{ padding: '4px', border: '1px solid #ddd' }}>{history.Remark || 'N/A'}</TableCell>
                      <TableCell sx={{ padding: '4px', border: '1px solid #ddd' }}>{history.Msg || 'N/A'}</TableCell>
   
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {hasActiveBooking && (
              <Box sx={{ padding: '16px', textAlign: 'center', borderTop: '1px solid #ddd' }}>
                <Typography variant="body1" sx={{ marginBottom: '12px', fontWeight: 'bold' }}>
                  Active booking found! Do you want to create a duplicate booking?
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    size="small"
                    onClick={() => onDuplicateConfirm(true)}
                    sx={{ minWidth: '60px' }}
                  >
                    Yes
                  </Button>
                  <Button 
                    variant="outlined" 
                    color="secondary" 
                    size="small"
                    onClick={() => onDuplicateConfirm(false)}
                    sx={{ minWidth: '60px' }}
                  >
                    No
                  </Button>
                </Box>
              </Box>
            )}
          </>
        ) : (
          <Typography variant="body1" align="center" sx={{ padding: '16px' }}>
            No history available
          </Typography>
        )}
      </DialogContent>
      
      {/* <DialogActions sx={{ padding: '8px', margin: 0 }}>
        <Button onClick={onClose} size="small">Close</Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default ResidentHistoryDialog;